import UserSettings_CrmContact from "./crm-contact";

/**
 * The user's per-company settings. A user can be in several companies, so the client data holds
 * one node per company id, and every getter here hands out the one `gd.companyId` names:
 * `gd.user.settings.company.crmContact` is the current company's.
 *
 * GOTCHA: a company this session never opened is never built into a settings object. toJson()
 * starts from the map as the server sent it and writes back only the nodes that were built, so
 * saving from one company neither drops another company's settings nor a key of this company that
 * no getter here covers.
 */
export default class UserSettings_Company {

    // the raw map, {companyId: {...}} - the source for everything not built below
    private config      : JSONObject

    private crmContacts : {[companyId: string]: UserSettings_CrmContact} = {}

    constructor(config: JSONObject) {
        this.config = config || {}
    }

    get crmContact(): UserSettings_CrmContact {

        const companyId = gd.companyId

        if (!this.crmContacts[companyId]) {
            this.crmContacts[companyId] = new UserSettings_CrmContact(
                _.get(this.config, [companyId, 'crmContact']) as JSONObject
            )
        }

        return this.crmContacts[companyId]
    }

    toJson(): JSONObject {

        const result: JSONObject = {...this.config}

        _.forEach(this.crmContacts, (crmContact: UserSettings_CrmContact, companyId: string) => {
            result[companyId] = {
                ...(result[companyId] as JSONObject),
                crmContact: crmContact.toJson(),
            }
        })

        return result
    }
}
